import type { ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';
import { Box, type SxProps, type Theme, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export interface OutlinedFieldContainerProps {
  label: string;
  error?: FieldError;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

const OutlinedFieldContainer = ({
  label,
  error,
  sx,
  children,
}: OutlinedFieldContainerProps) => (
  <>
    <Box
      component="fieldset"
      sx={{
        borderRadius: 1,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: (theme) =>
          error
            ? theme.palette.error.main
            : alpha(theme.palette.text.primary, 0.23),
        '&:hover': {
          borderColor: (theme) =>
            error ? theme.palette.error.main : theme.palette.text.primary,
        },
      }}
    >
      <Box
        component="legend"
        sx={{
          mx: 1,
          px: 0.5,
          fontSize: '0.75em',
          color: (theme) =>
            error ? theme.palette.error.main : theme.palette.text.secondary,
        }}
      >
        {label}
      </Box>
      <Box sx={sx}>{children}</Box>
    </Box>

    {error ? (
      <Typography
        variant="caption"
        color="error"
        sx={{ display: 'block', mt: 0.5, mx: 1.75 }}
      >
        {error?.message}
      </Typography>
    ) : null}
  </>
);

export default OutlinedFieldContainer;
